import { appGetState } from 'legacy/lut/store'

import { IFilter, IPaging, IPagingFromTo } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

interface IFetchCommitmentData {
  programType: string
  partnerId: string
  fYear: number
}

export const callProcedureJBPCommitmentDataInit = async ({
  programType,
  partnerId,
  fYear,
}: IFetchCommitmentData) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPCommitmentDataInit/call`)

  if (programType && partnerId && fYear) {
    const payload = {
      'p.PartnerId': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
    }

    const {
      app: { ownerId },
    } = appGetState()
    const [accessToken] = getTokens(ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    const rows = (response && response['Rows']) || []
    return { Data: rows }
  }
  return { Data: [] }
}
